import React, { useEffect, useState } from 'react';
import { Row, Col, Container } from 'react-bootstrap';

import LinkCard from '../../components/LinkCard';
import HorizontalLineIcon from '../../components/HorizontalLineIcon';
import Loading from '../../components/Loading';

import sanityClient from '../../sanity-client.js';
import imageUrlBuilder from '@sanity/image-url';
import { isMobile } from 'react-device-detect';

import './style.scss';

const builder = imageUrlBuilder(sanityClient);

function urlFor(source) {
  if (isMobile) {
    return builder.image(source).width(640).format('webp');
  }
  return builder.image(source).format('webp');
}

const About = () => {
  const [aboutData, setAboutData] = useState(null);

  function blocksToText(blocks) {
    return blocks.map((block) => block.children.map((child) => child.text));
  }

  useEffect(() => {
    sanityClient

      .fetch(
        `* [_id == "about"] {
					masthead {
					nameTitle,
					locationTitle,
					about,
					items[] {
						asset -> {
							_id,
							url,
							metadata {
								dimensions {
									aspectRatio
								},
								lqip,
							},
						},
					},
				},
				flatlay {
					asset -> {
						_id,
						url,
						metadata {
							lqip,
							dimensions {
								aspectRatio
							},
						},
					},
				},
				gear {
					items [] {
						asset -> {
							_id,
							url,
							metadata {
								lqip,
								dimensions {
									aspectRatio
								},
							},
						},
						title,
						alt,
					},
				}
			}`
      )
      .then((data) => setAboutData(data[0]))
      .catch(console.error);
  }, []);

  if (!aboutData) return <Loading />;
  return (
    <>
      <Container id="about">
        <Row id="top">
          {aboutData.masthead && (
            <Col>
              <div
                className="portrait__container lqip"
                style={{
                  backgroundImage: `url(${aboutData.masthead.items[0].asset.metadata.lqip})`,
                  paddingTop: `calc(100% / ${aboutData.masthead.items[0].asset.metadata.dimensions.aspectRatio})`
                }}
              >
                <img src={urlFor(aboutData.masthead.items[0].asset).url()} className="portrait__image" alt="" />

                <div className="title__wrap">
                  <h1 className="main-title">{aboutData.masthead.nameTitle}</h1>
                  <h2 className="sub-title">{aboutData.masthead.locationTitle}</h2>
                </div>
              </div>

              <p className="mt-5 text-center">{blocksToText(aboutData.masthead.about)}</p>
            </Col>
          )}
        </Row>

        <HorizontalLineIcon />

        <Container fluid as="main">
          <Row as="section">
            {aboutData.flatlay && (
              <Col
                className="masthead__container lqip"
                style={{
                  backgroundImage: `url(${aboutData.flatlay.asset.metadata.lqip})`,
                  paddingTop: `calc(100% / ${aboutData.flatlay.asset.metadata.dimensions.aspectRatio})`
                }}
              >
                <img src={urlFor(aboutData.flatlay.asset).url()} alt="" />
              </Col>
            )}
          </Row>

          <Row as="section" className="uses">
            {aboutData.gear &&
              aboutData.gear.items.map((item, index) => {
                return <LinkCard key={index} img={urlFor(item.asset).url()} name={item.title} alt={item.alt} {...item} />;
              })}
          </Row>
        </Container>
      </Container>
    </>
  );
};

export default About;
